module.exports = __webpack_public_path__ + "static/media/3.ff64c5f1.png";